var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_c('p',[_vm._v("Vue is awesome!")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.content))])]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_vm._v("\n        Vue is still awesome!\n        "),_c('p',[_vm._v(_vm._s(this.content))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }